var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formatter.config)?_c('div',[_c('ag-sub-input',{ref:"text",attrs:{"initText":_vm.formatter.config.text,"type":'textarea',"workflow":_vm.workflow,"placeholder":'Set to...',"rows":5,"maxRows":15,"noResize":true,"disabled":_vm.disableUI}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-386f44e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nodes/formatters/HashFormatter.vue
// module id = null
// module chunks = 